<template>
  <!-- Barra superior fija con menú hamburguesa -->
  <header ref="wrap" class="nav-wrap">
    <div class="nav-wrap__inner">
      <div class="nav">
        <a href="#inicio" class="nav__brand" @click="closeMenu">
          <img class="nav__emblem" :src="emblema" alt="" width="59" height="34" />
          <span class="nav__name">Cochera Belgrano</span>
        </a>

        <div class="nav__actions">
          <a
            class="btn btn--green nav__cta"
            :href="consultaUrl"
            target="_blank"
            rel="noopener noreferrer"
          >Escribinos</a>

          <button
            type="button"
            class="nav__toggle"
            :aria-expanded="isMenuOpen ? 'true' : 'false'"
            aria-controls="menu-principal"
            :aria-label="isMenuOpen ? 'Cerrar menú' : 'Abrir menú'"
            @click="toggleMenu"
          >
            <svg v-if="isMenuOpen" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
            <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>
        </div>
      </div>

      <transition name="menu">
        <nav v-if="isMenuOpen" id="menu-principal" class="menu" aria-label="Menú principal">
          <a href="#inicio" class="menu__link" @click="closeMenu">Inicio</a>
          <a href="#servicios" class="menu__link" @click="closeMenu">Servicios</a>
          <a href="#contacto" class="menu__link" @click="closeMenu">Contacto</a>
          <a :href="mapsUrl" class="menu__link" target="_blank" rel="noopener noreferrer" @click="closeMenu">Cómo llegar</a>
          <a :href="consultaUrl" class="btn btn--white menu__cta" target="_blank" rel="noopener noreferrer" @click="closeMenu">
            Escribinos por WhatsApp
          </a>
        </nav>
      </transition>
    </div>
  </header>
  <div class="nav-spacer" aria-hidden="true"></div>

  <!-- Portada -->
  <section id="inicio" class="hero">
    <span class="hero__stripe hero__stripe--a" aria-hidden="true"></span>
    <span class="hero__stripe hero__stripe--b" aria-hidden="true"></span>

    <div class="container hero__inner">
      <div class="hero__text">
        <p class="badge">
          <span class="badge__dot" aria-hidden="true"></span>
          Abierto las 24 hs
        </p>

        <h1 class="hero__title">
          Estacioná tranquilo. <span class="hero__accent">A cualquier hora.</span>
        </h1>

        <p class="hero__lead">Cochera segura en el centro de Mar del Plata, con vigilancia y valet parking.</p>

        <div class="hero__actions">
          <a class="btn btn--green" :href="consultaUrl" target="_blank" rel="noopener noreferrer">WhatsApp</a>
          <a class="btn btn--outline" :href="mapsUrl" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
              <path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" />
              <circle cx="12" cy="10" r="2.5" />
            </svg>
            {{ direccionCorta }}
          </a>
        </div>
      </div>

      <div class="hero__logo">
        <div class="logo-card">
          <img class="logo-card__img" :src="logo" alt="Logo de Cochera Belgrano" width="757" height="744" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { NEGOCIO, whatsappUrl } from '../config';
import emblema from '../assets/emblema-verde.png';
import logo from '../assets/logo-verde.png';

export default {
  name: 'AppHeader',
  data() {
    return {
      isMenuOpen: false,
      emblema,
      logo,
      direccionCorta: NEGOCIO.direccionCorta,
      mapsUrl: NEGOCIO.mapsUrl,
    };
  },
  computed: {
    consultaUrl() {
      return whatsappUrl();
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') this.closeMenu();
    },
    onDocumentClick(event) {
      // Cierra el menú al tocar fuera de la barra.
      // Se usa composedPath() porque Vue puede reemplazar el ícono del botón antes de que
      // este evento llegue acá, y entonces event.target ya no estaría dentro de la barra.
      const wrap = this.$refs.wrap;
      if (!this.isMenuOpen || !wrap) return;
      const path = event.composedPath ? event.composedPath() : [];
      if (!path.includes(wrap)) this.closeMenu();
    },
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onDocumentClick);
  },
};
</script>

<style scoped>
/* ---------- Barra ---------- */
/* Barra fija arriba de todo: position fixed funciona igual en Chrome, Firefox y Safari */
.nav-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding-top: env(safe-area-inset-top, 0px);
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 66, 37, 0.18);
  box-shadow: 0 2px 14px rgba(0, 66, 37, 0.1);
}

/* Reserva el lugar de la barra para que no tape la portada */
.nav-spacer {
  height: calc(64px + env(safe-area-inset-top, 0px));
}

.nav-wrap__inner {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 max(16px, env(safe-area-inset-right)) 0 max(16px, env(safe-area-inset-left));
}

.nav {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.nav__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  color: var(--green);
  text-decoration: none;
}

.nav__emblem {
  flex: none;
  display: block;
  width: auto;
  height: 34px;
}

.nav__name {
  font-family: var(--display);
  font-weight: 800;
  font-size: 15px;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.nav__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.nav__cta {
  min-height: 0;
  padding: 12px 20px;
  font-size: 15px;
}

.nav__toggle {
  flex: none;
  width: 48px;
  height: 48px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--green);
  color: #ffffff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

/* ---------- Menú desplegable ---------- */
.menu {
  position: absolute;
  top: calc(100% + 8px);
  right: max(16px, env(safe-area-inset-right));
  width: min(360px, calc(100% - 32px));
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px;
  border-radius: 28px;
  background: var(--green);
  box-shadow: 0 24px 60px rgba(0, 40, 22, 0.45);
}

.menu__link {
  padding: 16px 18px;
  border-radius: 16px;
  color: #ffffff;
  font-family: var(--display);
  font-weight: 600;
  font-size: 18px;
  text-decoration: none;
}

.menu__link:hover {
  background: rgba(255, 255, 255, 0.12);
}

.menu__cta {
  margin-top: 8px;
  border-radius: 16px;
  white-space: normal;
}

.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* ---------- Portada ---------- */
.hero {
  position: relative;
  overflow: hidden;
  scroll-margin-top: 72px;
}

.hero__stripe {
  position: absolute;
  top: -40px;
  bottom: -40px;
  transform: skewX(-22deg);
  pointer-events: none;
}

.hero__stripe--a {
  right: 6%;
  width: 90px;
  background: #e6f2ea;
}

.hero__stripe--b {
  right: calc(6% + 130px);
  width: 46px;
  background: #eef6f1;
}

.hero__inner {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 44px;
  padding-top: 36px;
  padding-bottom: 64px;
}

.hero__text {
  flex: 1 1 440px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.badge {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 8px 16px 8px 14px;
  border-radius: 999px;
  background: #e3f3e9;
  border: 1px solid #9ed3b2;
  font-family: var(--mono);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--green-mid);
}

.badge__dot {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #1f9d5f;
}

.badge__dot::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: inherit;
  animation: pulse 1.8s ease-out infinite;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(2.6); opacity: 0; }
}

.hero__title {
  margin: 0;
  font-family: var(--display);
  font-weight: 800;
  font-size: clamp(28px, 6.4vw, 68px);
  line-height: 1.06;
  letter-spacing: -0.02em;
  color: var(--green);
  text-wrap: balance;
}

.hero__accent {
  background: linear-gradient(100deg, #004225, #2fa36b 85%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hero__lead {
  margin: 0;
  max-width: 480px;
  font-size: clamp(17px, 2vw, 20px);
  color: var(--muted);
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hero__logo {
  flex: 1 1 340px;
  min-width: 0;
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  padding: 0 12px 12px 0;
}

.logo-card {
  display: flex;
  justify-content: center;
  padding: 32px 28px;
  border-radius: 36px;
  background: #ffffff;
  border: 2.5px solid var(--green);
  box-shadow: 12px 12px 0 var(--green);
}

.logo-card__img {
  display: block;
  width: 88%;
  height: auto;
  animation: rise 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes rise {
  from { transform: translateY(16px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* ---------- Celular ---------- */
@media (max-width: 560px) {
  .nav__cta {
    display: none;
  }

  /* El nombre pasa a dos líneas para no quedar tapado por el botón del menú */
  .nav__emblem {
    height: 28px;
  }

  .nav__name {
    max-width: 104px;
    font-size: 12.5px;
    line-height: 1.1;
    white-space: normal;
  }

  .hero__inner {
    gap: 32px;
    padding-top: 22px;
    padding-bottom: 48px;
  }

  .hero__text {
    gap: 22px;
  }

  .hero__actions .btn {
    flex: 1 1 100%;
  }

  /* Logo más chico para que no ocupe toda la pantalla */
  .hero__logo {
    max-width: 290px;
    padding: 0 8px 8px 0;
  }

  .logo-card {
    padding: 22px 20px;
    border-radius: 28px;
    box-shadow: 8px 8px 0 var(--green);
  }
}

@media (prefers-reduced-motion: reduce) {
  .badge__dot::after,
  .logo-card__img {
    animation: none;
  }
}
</style>
